var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"phone"}},[_c('MazPhoneNumberInput',{ref:"input",staticClass:"pb-2",class:{ 'border-bottom-blue': this.payload && this.payload.isValid },attrs:{"preferred-countries":['FR', 'BE', 'DE', 'GB', 'CA', 'US'],"default-country-code":"FR","translations":{
      countrySelectorLabel: 'Code pays',
      countrySelectorError: 'Choisir un pays',
      phoneNumberLabel: 'Numéro de téléphone',
      example: 'Exemple :',
    }},on:{"update":_vm.setPayload,"clear":_vm.clearPhone},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }